import { render } from "./LottosMain.vue?vue&type=template&id=3e13f8a1&scoped=true"
import script from "./LottosMain.vue?vue&type=script&lang=js"
export * from "./LottosMain.vue?vue&type=script&lang=js"

import "./LottosMain.vue?vue&type=style&index=0&id=3e13f8a1&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e13f8a1"]])

export default __exports__